<script>
  import page from "page";
  import { status } from "./status.js";
  import { tl } from "./multilang.js";
  import { fade } from 'svelte/transition';
  import { postToHubSpot } from "./component/hubSpotHelper.js";
  import { onMount } from "svelte";

  async function postHubsPotForm() {
        formLoader = true;

        const siteURL = "zaas.zoftoken.com";

        let fields = [ //Rodrigo: el form actual que tengo definido no soporta estoy 4 campos... me falta crearlo en hubspot y pasarte el ID
                {
                  "name": "email",
                  "value": emailContactUs
                },
                {
                  "name": "message",
                  "value": messageContactUs
                },
                {
                  "name": "firstname",
                  "value": firstNameContactUs
                },
                {
                  "name": "lastname",
                  "value": lastNameContactUs
                },
                {
                  "name": "company",
                  "value": companyContactUs
                }
              ]

        postToHubSpot(fields, siteURL + $status.path, document.title, 'CONTACT') 
            .then(async (postResults) => {
                formLoader = false;    
                formResult = "<p class='has-text-success'><b>" + tl("Succesful submission") + "</b></p>" + postResults.inlineMessage;
            })
            .catch(async (error) => {
                formLoader = false;   
                formError = true;
                formResult = "<p class='has-text-danger'><b>" + error.message + "</b></p><p>" + error.errors[0].message + "</p>";
            });
    }

    function retryForm () {
      formResult = '';
      formError = false;
    }

  onMount(() => {
    $status.notification.show = false;
    $status.notification.confirm = false;
  });
  
  let contactUsModalFlag = false;

  let emailContactUs = '';
  let messageContactUs = '';
  let firstNameContactUs = '';
  let lastNameContactUs = '';
  let companyContactUs = '';

  let formLoader = false;
  let formResult = '';
  let formError = false;
</script>

<style>
.zt-illustration{
  background-image: url(../assets/landing-illustration.svg);
  background-repeat: no-repeat;
  background-size: 90%;
  position: relative;
}

.store-wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 32rem;
  right: 9rem;
}
  
.store-wrapper ul {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: baseline;
  z-index: 1;
}

.store-wrapper ul li{
  list-style: none;
  list-style-image: none;
  list-style-type: none;
  margin-right: 1rem;
}

.store-wrapper ul li:last-child{
  margin-right: 0;
}

img.iphone{
    position: relative;
    right: 21rem;
    top: 7rem;
    z-index: 0;
}

.price-list-wrapper{
  padding-bottom: 7rem;
  margin-top: 0;
}

.price-list-wrapper h2{
  padding: 4rem 0 2rem 0;
}

.price-list-wrapper:before{
  content: ' ';
  background-color: hsl(200, 18%, 97%);
  width: 100%;
  display: block;
  height: 54rem;
  position: absolute;
  padding-top: 3rem;
}

.price-list{
  margin-top: 6rem;
}

.price-list .column{
  border-right: 1px dotted hsl(222, 19%, 80%);
}

.price-list .column:last-child{
  border-right: none;
}

.price-list .box{
  box-shadow: 6px 6px 16px #00000014;
}

.price-list .tile{
  position: relative;
}

.price-list .tile article{
  display: flex;
  flex-direction: column;
}

.price-list .tile .buttons{
  margin-top: auto;
}

.price-list .title{
    font-weight: bold;
    padding: 1rem 0;
}

.price-list img.imago{
  position: absolute;
  top: -6rem;
  margin: 0 40%;
}

.price-list li{
  font-weight: bold;
}

.price-list .option-basic .title{
  color:hsl(155, 64%, 45%);
  background-color: #D8FFEF;
}

.price-list .option-basic li{
  color:hsl(155, 64%, 45%);
}

.price-list .option-onpremise .title{
  color:hsl(338, 78%, 48%);
  background-color: #FFE3ED;
}

.price-list .option-onpremise li{
  color:hsl(338, 78%, 48%);
}

.price-list .option-pro .title{
  color:hsl(196, 87%, 41%);
  background-color: #D7F0F9;
}

.price-list .option-pro li{
  color:hsl(196, 87%, 41%);
}

.price-list .option-pro .tier-wrapper .tier{
    line-height: 2.7rem;
    margin-bottom: 1rem;
}

.has-text-right li{
	padding: 18px 0 18px 42px;
	list-style: none;
	background-image: url('https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Yes_Check_Circle.svg/1200px-Yes_Check_Circle.svg.png');
	background-repeat: no-repeat;
	background-position: left center;
	background-size: 20px;
}

ul.zt-ul-li-imago {
  margin-left: 0;
}

ul.zt-ul-li-imago li{
  list-style: none;
  list-style-image: none;
  padding-left: 3.2rem;
  background-image: url(/assets/imagotick.svg);
  background-repeat: no-repeat;
  background-position: left top .5rem;
  background-size: 1.8rem;
  margin-bottom: 1rem;
}

/* START Media Breakpoints */

@media only screen and (max-width: 1408px) {
  .store-wrapper{
    top: 29rem;
  }
  img.iphone {
    position: relative;
    right: 21rem;
    top: 7rem;
  }
}

@media only screen and (max-width: 1216px) {
  .store-wrapper{
    top: 22rem;
  }
  img.iphone {
      right: 8rem;
      top: -5rem;
      width: 60%;
  }
}

@media only screen and (max-width: 1024px) {
  img.iphone {
    right: 6rem;
  }
}

@media only screen and (max-width: 769px) {
  .store-wrapper {
    position: relative;
    top: 15vh;
    right: 0;
  }
  .zt-illustration {
    min-height: 30rem;
    background-size: 50%;
    background-position: top center;
  }
  img.iphone {
    display: none;
  }
  .price-list img.imago {
      display: none;
  }
  .price-list .tile{
    margin-bottom: 3rem;
  }
  .has-text-right{
    text-align: left !important;
  }
}

/* END Media Breakpoints */

</style>

<svelte:head>
  <title>ZaaS - ZofToken as a Service</title>
</svelte:head>


<section class="main">
  <div class="container">
    <div class="content">

      <!-- START Hero -->
        <div class="columns">
          <div class="column is-half zt-illustration">
            <div class="store-wrapper">
              <h2 class="is-uppercase is-text-centered is-size-6">{tl("Download app")}</h2>
              <ul>
                <li><a href="https://apps.apple.com/uy/app/zoftoken/id1501417813" target="_blank"><img src="assets/apple-store.svg" alt="Apple Store"></a></li>
                <li><a href="https://play.google.com/store/apps/details?id=zoftoken.mobile.Android" target="_blank"><img src="assets/googleplay-store.svg" alt="Google Play Store"></a></li>
              </ul>
            </div>
            <img src="assets/iphonex-perspective.png" class="iphone" alt="iPhone X" />
          </div>
          <div class="column">
            <div class="columns">
              <div class="column is-four-fifths">
                  <h1 class="is-size-1 has-text-primary">{tl("What is ZofToken as a Service (ZaaS)?")}</h1>
                <p class="is-size-5">{tl("Even though we generally discourage outsourcing your security, we offer most of ZofToken's features in our cloud environment, so you can easily create services and test your integrations, as well as, if it fits your business requirements, run your own 2FA solution as a service.")}</p>
                <h2 class="is-size-2 has-text-primary">{tl("What are the available features?")}</h2>
                <p class="is-size-5">{tl("The majority of features of the stand-alone version are available, including:")}:</p>
                <ul class="zt-ul-li-imago">
                  <li class="is-size-5">{tl("Create an unlimited number of services")}</li>
                  <li class="is-size-5">{tl("Manage all their configuration options")}</li>
                  <li class="is-size-5">{tl("Create and manage users/tokens")}</li>
                  <li class="is-size-5">{tl("Access token status through polling and webhooks")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- END Hero -->
    </div>
  </div>
</section>

<section class="main price-list-wrapper">
    <div class="container">
        <div class="content">
          <!-- START Price list -->
          <h2 class="is-uppercase has-text-centered is-size-2">{tl("Pricing")}</h2>

          <div class="tile is-ancestor price-list">
              <div class="tile is-parent option-basic">
                <article class="tile is-child box">
                  <img src="assets/imago-green.svg" class="imago imago-green" alt="ZofToken Basic">
                  <p class="title is-4 is-uppercase has-text-centered	">{tl("Basic")}</p>
                  <ul>
                    <li>{tl("Up to 20 users")}</li>
                    <li>{tl("Unlimited services and configuration")}</li>
                    <li>{tl("Low priority support")}</li>
                    <li>{tl("Ideal for enthusiasts and internal use in small groups")}</li>
                    <li>{tl("Recommended for experiments and integration tests")}</li>
                  </ul>
                  <div class="buttons">
                      <button class="button is-success is-fullwidth" on:click={() => page('/registration')}>{tl("Sign up for free")}</button>
                    </div>
                </article>
              </div>
  
              <div class="tile is-parent option-pro">
                <article class="tile is-child box">
                  <img src="assets/imago-blue.svg" class="imago" alt="ZofToken Enterprise">
                  <p class="title is-4 is-uppercase has-text-centered	">{tl("Enterprise")}</p>
                  <div class="columns">
                    <div class="column tier-wrapper">
                      <p class="is-size-8 is-uppercase has-text-centered is-blue has-text-weight-bold">{tl("Tier 1")}</p>
                      <p class="tier is-uppercase has-text-centered is-size-2 has-text-weight-bold">
                        <span class="is-size-7 has-text-weight-normal is-block">{tl("Up to")}</span>
                        500
                        <span class="is-size-7 has-text-weight-normal is-block">{tl("users")}</span>
                      </p>
                      <p class="price is-uppercase has-text-centered is-size-6">
                          <span class="is-size-9 is-block">{tl("price")}</span>
                          2.000 USD / {tl("year")}
                        </p>
                    </div>
                    <div class="column tier-wrapper">
                      <p class="is-size-8 is-uppercase has-text-centered is-blue has-text-weight-bold">{tl("Tier 2")}</p>
                      <p class="tier is-uppercase has-text-centered is-size-2 has-text-weight-bold">
                        <span class="is-size-7 has-text-weight-normal is-block">{tl("Up to")}</span>
                        2,000
                        <span class="is-size-7 has-text-weight-normal is-block">{tl("users")}</span>
                      </p>
                      <p class="price is-uppercase has-text-centered is-size-6">
                          <span class="is-size-9 is-block">{tl("price")}</span>
                          5.000 USD / {tl("year")}
                        </p>
                    </div>
                  </div>
                  <ul>
                    <li>{tl("Fully managed cloud 2FA solution")}</li>
                    <li>{tl("High priority support")}</li>
                    <li>{tl("Ideal for internal use in low to mid-sized companies and external use for premium customers or business partners")}</li>
                  </ul>
                  <div class="buttons">
                      <button class="button is-primary is-blue is-fullwidth" on:click={() => {contactUsModalFlag = true}}>{tl("Contact us")}</button>
                    </div>
                </article>
              </div>
  
              <div class="tile is-parent option-onpremise">
                <article class="tile is-child box">
                  <img src="assets/imago-pink.svg" class="imago" alt="ZofToken Custom">
                  <p class="title is-4 is-uppercase has-text-centered	">{tl("Custom")}</p>
                  <ul>
                    <li>{tl("For companies requiring higher numbers of users, a private")} <a href="https://zoftoken.com/products.html">ZofToken</a> {tl("instance is the recommended approach as it will provide significantly cheaper costs and full autonomy")}</li>
                    <li>{tl("However, if you still prefer a managed solution, we can work with you to provide a custom design and pricing")}</li>
                    <li>{tl("We are also open to discussing partnership or reseller agreements with service organizations that could add value to their customers through our solution")}</li>
                  </ul>
                  <div class="buttons">
                          <button class="button is-primary is-pink is-fullwidth" on:click={() => {contactUsModalFlag = true}}>{tl("Contact us")}</button>
                    </div>
                </article>
              </div>
            </div>
            <!-- END Price list -->
        </div>
    </div>

</section>

{#if contactUsModalFlag}
<div class="modal is-active" transition:fade="{{ duration: 200 }}">
  <div class="modal-background" on:click={() => {contactUsModalFlag = false}}></div>
  <div class="modal-card">
    <header class="modal-card-head card-heading">
      <p class="modal-card-title has-text-weight-semibold has-text-white">{tl("Contact us")}</p>
      <button class="delete is-large" aria-label="close" on:click={() => {contactUsModalFlag = false}}></button>
    </header>
    <section class="modal-card-body">
            {#if formResult}
              {@html formResult}
              {#if formError}
                <button class="button is-primary" on:click={() => retryForm()} >{tl("Retry")}</button>
              {/if}
            {:else}
            <div class="zt-field-wrapper">
              <p><b>{tl("Be among the first to have access to our cloud services.")}</b></p><br />
              <p>{tl("Please provide your contact information and we will get back to you as soon as possible.")}</p>
            </div>
            <div class="columns">
              <div class="column">
                <div class="zt-field-wrapper">
                  <label class="zt-label">{tl("First name")}*</label>
                  <input type="text" class="input extend gap gap-bottom" bind:value={firstNameContactUs} placeholder="{tl("John")}">
                </div>
              </div>

              <div class="column">
                <div class="zt-field-wrapper">
                  <label class="zt-label">{tl("Last name")}*</label>
                  <input type="text" class="input extend gap gap-bottom" bind:value={lastNameContactUs} placeholder="{tl("Doe")}">
                </div>
              </div>
            </div>

            <div class="zt-field-wrapper">
              <label class="zt-label">{tl("Company")}</label>
              <input type="text" class="input gap gap-bottom" bind:value={companyContactUs} placeholder="ACME">
            </div>

            <div class="zt-field-wrapper">
              <label class="zt-label">{tl("Email")}*</label>
              <input type="email" class="input gap gap-bottom" bind:value={emailContactUs} placeholder="{tl("john-doe@domain.com")}">
            </div>

            <div class="zt-field-wrapper">
              <label class="zt-label">{tl("Message")}</label>
              <textarea class="textarea" placeholder="{tl("e.g. I want to schedule an online meeting to discuss the security details of ZofToken.")}" bind:value={messageContactUs}/>
            </div>
            {/if}
    </section>
    <footer class="modal-card-foot">
    {#if !formResult}
      <button class="button is-primary" on:click={() => postHubsPotForm()} class:is-loading={formLoader} disabled={!firstNameContactUs ||! lastNameContactUs || !emailContactUs}>{tl("Submit")}</button>
    {/if}
      <button class="button" on:click={() => {contactUsModalFlag = false}}>{tl("Close")}</button>
    </footer>
  </div>
</div>
{/if}